import React, { useEffect, useMemo, useState } from "react";
import { apiJson } from "../../auth/authClient";

const API = "/api/udrzba";

function money(v) {
  return `${Number(v || 0).toLocaleString("cs-CZ")} Kč`;
}

function toCsvValue(v) {
  const s = String(v ?? "");
  return `"${s.replace(/"/g, '""')}"`;
}

function downloadCsv(filename, rows) {
  const csv = rows.map((r) => r.map(toCsvValue).join(";")).join("\n");
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export default function UdrzbaUcetnictvi() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    apiJson(`${API}/zakazky`, { method: "GET" })
      .then((d) => setItems(Array.isArray(d?.items) ? d.items : []))
      .catch(() => setItems([]));
  }, []);

  const excludedStates = new Set(["zruseno", "zdarma", "interni_test"]);
  const accounted = useMemo(
    () => items.filter((x) => !excludedStates.has(String(x.stav || "").trim())),
    [items]
  );

  const nezaplacene = useMemo(
    () => accounted.filter((x) => String(x.financniStav || "") !== "zaplaceno"),
    [accounted]
  );
  const zaplacene = useMemo(
    () => accounted.filter((x) => String(x.financniStav || "") === "zaplaceno"),
    [accounted]
  );

  const totalNezaplacene = useMemo(
    () => nezaplacene.reduce((sum, x) => sum + Number(x?.doplatekCastka || 0), 0),
    [nezaplacene]
  );
  const totalZaplacene = useMemo(
    () => zaplacene.reduce((sum, x) => sum + Number(x?.uhrazenoCelkem || 0), 0),
    [zaplacene]
  );

    const makeRows = (src) => {
      const rows = [
        [
          "ID",
          "Objednavatel",
          "Telefon",
          "Email",
          "Číslo hrobu",
          "Hřbitov",
          "Datum objednání",
          "Plánované datum",
          "Datum zhotovení",
          "Stav",
          "Cena celkem",
          "Uhrazeno celkem",
          "Doplatek",
          "Finanční stav"
        ]
      ];

      src.forEach((x) => {
        rows.push([
          x.id,
          x.objednavatel,
          x.telefon,
          x.email,
          x.cisloHrobu,
          x.hrbitov,
          x.datumObjednani,
          x.planovaneDatum,
          x.datumZhotoveni,
          x.stav,
          Number(x?.cenaCelkem || 0),
          Number(x?.uhrazenoCelkem || 0),
          Number(x?.doplatekCastka || 0),
          String(x.financniStav || ""),
        ]);
      });

      return rows;
    };

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Účetnictví</h2>
      <div style={{ marginBottom: 16, color: "#6b7280" }}>
        Do účetních přehledů nejsou zahrnuté stavy: Zrušeno, Zdarma, Interní test.
      </div>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 18 }}>
        <button onClick={() => downloadCsv(`udrzba-nezaplacene-${new Date().toISOString().slice(0,10)}.csv`, makeRows(nezaplacene))}>
          Export nezaplacené CSV
        </button>
        <button onClick={() => downloadCsv(`udrzba-zaplacene-${new Date().toISOString().slice(0,10)}.csv`, makeRows(zaplacene))}>
          Export zaplacené CSV
        </button>
        <button onClick={() => downloadCsv(`udrzba-vse-ucetnictvi-${new Date().toISOString().slice(0,10)}.csv`, makeRows(accounted))}>
          Export vše CSV
        </button>
      </div>

      <h3>Nezaplacené zakázky</h3>
      {nezaplacene.map((x) => (
        <div key={x.id} style={{ padding: "10px 0", borderBottom: "1px solid #f1f5f9" }}>
          {x.id} — {x.objednavatel} — {money(x?.doplatekCastka || 0)}
        </div>
      ))}
      {!nezaplacene.length && <div style={{ color: "#6b7280" }}>Nic tu není.</div>}
      <div style={{ marginTop: 10, fontWeight: 800 }}>Celkem nezaplacené: {money(totalNezaplacene)}</div>

      <h3 style={{ marginTop: 22 }}>Zaplacené zakázky</h3>
      {zaplacene.map((x) => (
        <div key={x.id} style={{ padding: "10px 0", borderBottom: "1px solid #f1f5f9" }}>
          {x.id} — {x.objednavatel} — {money(x?.uhrazenoCelkem || 0)}
        </div>
      ))}
      {!zaplacene.length && <div style={{ color: "#6b7280" }}>Nic tu není.</div>}
      <div style={{ marginTop: 10, fontWeight: 800 }}>Celkem zaplacené: {money(totalZaplacene)}</div>
    </div>
  );
}
